import { useCallback } from 'react';
import { useFeatureFlagsContext } from '../ui/FeatureFlagsContext/FeatureFlagsContext';

export enum Features {
  eventPostbacksReview = 'eventPostbacksReview',
  lifetimeSelectTwoYearsExtension = 'lifetimeSelectTwoYearsExtension',
  lifetimeSelectThreeYearsExtension = 'lifetimeSelectThreeYearsExtension',
  dashboards = 'dashboards',
  overview = 'overview',
}

enum AccessEntity {
  user = 'user',
  company = 'company',
  organization = 'organization',
}
type AccessRecord =
  | {
      type: AccessEntity.company;
      postfix: string;
    }
  | { type: AccessEntity.user; email: string }
  | { type: AccessEntity.organization; organizationId: string };

const FEATURE_GROUPS: Record<Features, AccessRecord[]> = {
  [Features.eventPostbacksReview]: [
    { type: AccessEntity.company, postfix: 'campaignswell.com' },
  ],
  [Features.lifetimeSelectTwoYearsExtension]: [
    {
      type: AccessEntity.organization,
      organizationId: '4a6b0c93-ecda-46ea-bd58-92553abb73ae',
    },
    {
      type: AccessEntity.organization,
      organizationId: '7c2d76c6-b64a-4cc8-87e0-d5c303e77765',
    },
  ],
  [Features.lifetimeSelectThreeYearsExtension]: [
    {
      type: AccessEntity.organization,
      organizationId: 'dd59e7c3-7668-47d9-999c-7909cfabe234',
    },
  ],
  [Features.dashboards]: [
    {
      type: AccessEntity.user,
      email: 'aliaksei@campaignswell.com',
    },
  ],
  [Features.overview]: [
    { type: AccessEntity.company, postfix: 'campaignswell.com' },
  ],
};

export const useFeatureFlags = () => {
  const { email, organizationId } = useFeatureFlagsContext();
  const isFeatureAvailable = useCallback(
    (feature: Features) => {
      const groups = FEATURE_GROUPS[feature];

      return (
        !!email &&
        groups.some((group) => {
          switch (group.type) {
            case AccessEntity.company:
              return email.endsWith(group.postfix);
            case AccessEntity.user:
              return email === group.email;
            case AccessEntity.organization:
              return organizationId === group.organizationId;
          }

          return false;
        })
      );
    },
    [email, organizationId],
  );

  return {
    isFeatureAvailable,
  };
};
